// useAnimation.js
import { useEffect, useState } from "react";

const useAnimation = (duration = 1000) => {
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false); // hide the animation
    }, duration);
    return () => clearTimeout(timer); // clear timer
  }, [duration]);
  return isAnimating;
};
export default useAnimation;
